import * as React from 'react';
// import Stores from '../components/Stores';
import Gallery from '../components/Gallery';
import BlogQuery from '../components/Query/Blog';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';

import {
  Title, Section, Container,
  Jumbotron, Breadcrumbs, Loader
} from '../modules/modules';

interface IBlogArticleState {}
interface IBlogArticleProps extends RouteComponentProps<{ language: string, articleId: string }> {}

class BlogArticle extends React.Component<IBlogArticleProps> {

  public state: IBlogArticleState;

  constructor(props: IBlogArticleProps) {
    super(props);

    this.state = {};
  }

  public render() {
    const articleId = this.props.match.params.articleId;
    
    return (<BlogQuery>
      {({ blogposts: { blogposts, loading }}: any) => {
        if (loading) {
          return (<Loader />);
        }

        const item = blogposts.find((i: any) => i.id === articleId);
        return (<React.Fragment>
          <Jumbotron type="sm" background="/img/blog-jumbo.jpg">
            <small>{process.env.REACT_APP_PROJECT_NAME}</small>
            Blog
          </Jumbotron>
          <Section type="article">
            <Container type="md">
              <Breadcrumbs
                links={[
                  { value: 'Úvod' },
                  { value: 'Blog' },
                  { value: item.title }
                ]}
              />
              <div className="blogItem">
                <Title type="article">
                  {item.title}
                </Title>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </div>
            </Container>
          </Section>
          {/* <Stores /> */}
        </React.Fragment>);
      }}
      </BlogQuery>);
  }
}

export default withRouter(BlogArticle);



// WEBPACK FOOTER //
// ./src/pages/BlogArticle.tsx